module.exports = __webpack_public_path__ + "img/dots.c663ee16.svg";